<template>
  <div class="offline-tail-money-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" title="上传合同凭证" :showBack="true"></my-header>
    <div class="offline-tail-money-form">
      <div class="input-group">
        <div class="input-label">收款商户</div>
        <input class="mint-field-core form-input" v-model="shopName" readonly="readonly">
      </div>
      <div class="input-group">
        <div class="input-label">联系人</div>
        <input class="mint-field-core form-input" type="text" v-model="name" placeholder="请输入联系人姓名">
      </div>
      <div class="input-group">
        <div class="input-label">联系电话</div>
        <input class="mint-field-core form-input" type="number" v-model="phone" placeholder="请输入联系电话">
      </div>
      <div class="input-group">
        <div class="input-label">收货地址</div>
        <input class="mint-field-core form-input" type="text" v-model="receiveAddress" placeholder="请输入收货地址">

      </div>
      <div class="input-group">
        <div class="input-label">送货期限</div>
        <input class="mint-field-core form-input" readonly="readonly" @click="open('endTimePicker')" v-model="deliverLimit" placeholder="请选择送货期限">
        <mt-datetime-picker ref="endTimePicker" @confirm="setDeliverLimitTime" v-model="deliverLimitTime" type="date" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日">
        </mt-datetime-picker>
      </div>
      <div class="input-group">
        <div class="input-label">总金额</div>
        <input class="mint-field-core form-input" type="number" v-model="amountMoney"  placeholder="请输入订单总金额">
      </div>
      <div class="input-group">
        <div class="input-label">买家留言</div>
        <input class="mint-field-core form-input" type="text" v-model="message" placeholder="请输入您对商家留言">
      </div>
      <div class="input-group">
        <div class="input-label">备注</div>
        <input class="mint-field-core form-input" type="text" v-model="remarks" placeholder="订单备注">
      </div>
      <div class="evaluate">
        <span class="evaluate-field">交易评分</span>
        <span @click="selectEvaluateScore('1')">
          <img v-if="evaluateScore == '1'" class="icon-select" src="../../assets/icon/icon-selected.png">
          <img v-if="evaluateScore == '2'" class="icon-select" src="../../assets/icon/icon-unselected.png">
          <span>满意</span></span>
        <span @click="selectEvaluateScore('2')" class="evaluate-bad">
          <img v-if="evaluateScore == '1'" class="icon-select" src="../../assets/icon/icon-unselected.png">
          <img v-if="evaluateScore == '2'" class="icon-select" src="../../assets/icon/icon-selected.png">
          <span>不满意</span></span>
      </div>
      <div class="input-group">
        <div class="input-label">交易评价</div>
        <input class="mint-field-core form-input" type="text" v-model="evaluateContent" placeholder="请写下你对本次交易的评价">
      </div>
      <div class="record-img border-top-style">
        <div class="image-area">
          <div class="image-view">
            <div v-if="attachmentUrlList.length>0" v-for="(recoredImg,index) in attachmentUrlList">
              <div class="image" :data-index="index" style="position: relative">
                <img :src="imgUrl+recoredImg" @click.stop="optionImage(index,$event)">
              </div>
            </div>
            <div>
              <div class="image add-image" @click.stop="addImage()">
                <span class="icon-plus"><img src="../../assets/icon/icon-plus.png"></span>
                <span style="display: none;"><input type="file" id="image-input" multiple accept="image/*"></span>
              </div>
              <div>上传凭证</div>
            </div>
          </div>
        </div>
      </div>
      <div class="trade-amount-info">
        <div class="amount-info-item">
          <div>订金总金额</div><div class="amount-info-value">¥{{amountMoney}}</div>
        </div>
        <div class="amount-info-item">
          <div>订金抵扣</div><div class="amount-info-value">¥{{deposit}}</div>
        </div>
        <div class="payable-amount border-top-style">支付尾款金额 : <span class="amount-info-value">¥{{amount}}</span></div>
      </div>
      <div class="form-btn" @click="savePayVoucher">保存</div>
    </div>
  </div>
</template>

<script>
  import {Indicator,Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import baseService from '../../service/BaseService';
  import lrz from 'lrz';
  import {imgUrl} from "../../config";
  import tradeOfflineService from '../../service/trade/TradeOfflineService'
  import customerAddressService from '../../service/customer/CustomerAddressService'

  export default {
    name: 'OfflinePayVoucher',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        imgUrl:imgUrl,
        shopName:'',
        shopId:'',
        tradeOfflineId:'',
        type:'3',
        tradeOffline:{},
        promotionList:[],
        name:'',
        phone:'',
        receiveAddress:'',
        amountMoney:'',
        amount:0,
        deposit:0,
        message:'',
        remarks:'',
        addressId:'',
        deliverLimit:'',
        deliverLimitTime:new Date(),
        evaluateScore:'1',
        evaluateContent:'',
        attachmentUrlList:[],
        attachmentIds:'',
        isWechatBrowser:this.$verfyBrowserType()
      }
    },
    created(){
      this.shopName = this.$route.query.shopName;
      this.tradeOfflineId = this.$route.query.tradeOfflineId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getCustomerDefaultAddress();
      this.getTradeOfflineDetail();
      //增加Date对象方法
      Date.prototype.format = function (fmt) { //author: meizz
        var o = {
          "M+": this.getMonth() + 1, //月份
          "d+": this.getDate(), //日
          "H+": this.getHours(), //小时
          "m+": this.getMinutes(), //分
          "s+": this.getSeconds(), //秒
          "q+": Math.floor((this.getMonth() + 3) / 3), //季度
          "S": this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
          if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
      }
    },
    watch:{
      amountMoney(value){
        this.amount = value - this.deposit;
      }
    },
    methods: {
      async getCustomerDefaultAddress(){
        let {code,msg,data} = await customerAddressService.getDefault();
        if(code == '0'){
          this.addressId = data.id;
          this.name = data.receiver;
          this.phone = data.phone;
          this.receiveAddress = data.address;
        }else {
          Toast(msg);
        }
      },
      async getTradeOfflineDetail(){
        let {code,msg,data} = await tradeOfflineService.detail(this.tradeOfflineId);
        if(code == '0'){
          this.tradeOffline = data.offline;
          this.type = this.tradeOffline.type;
          this.deposit = this.tradeOffline.payMoney;
          this.shopId = this.tradeOffline.shopId;
        }else {
          Toast(msg);
        }
      },
      open(picker) {
        this.$refs[picker].open();
      },
      setDeliverLimitTime(value) {
        this.deliverLimit = value.format("yyyy-MM-dd");
      },
      selectEvaluateScore(score){
        this.evaluateScore = score;
      },
      async savePayVoucher(){
        if(!this.name){
          Toast('请输入联系人姓名');
          return false;
        }
        if(!this.phone){
          Toast('请输入联系电话');
          return false;
        }
        let re= /^1[3578]\d{9}$/;
        if(!re.test(this.phone)){
          Toast('您输入的手机号码有误,请重新输入!');
          return false;
        }
        if(!this.receiveAddress){
          Toast('请输入收货地址');
          return false;
        }
        var reg = /^(([1-9]\d*)|0)(\.\d{1,2})?$/;
        if(!this.amountMoney){
          Toast('请输入订单总金额');
          return false;
        }else if(!reg.test(this.amountMoney)){
          Toast('请输入正确的订单总金额');
          return false;
        }
        if(this.deposit && this.amountMoney <= this.deposit){
          Toast('总金额必须大于抵扣金额');
          return false;
        }
        if(!this.attachmentIds){
          Toast('请上传支付凭证');
          return false;
        }

        this.attachmentIds = this.attachmentIds.substring(1,this.attachmentIds.length);
        let tradeOfflineFormData = {tradeOfflineId:this.tradeOffline.id,offlineType:this.type,shopId:this.shopId,amount:this.amountMoney,name:this.name,phone:this.phone,receiveAddress:this.receiveAddress,attachmentIds:this.attachmentIds,
          addressId:this.addressId,message:this.message,remarks:this.remarks,deliverLimit:this.deliverLimit,evaluateScore:this.evaluateScore,evaluateContent:this.evaluateContent};
        let result = await tradeOfflineService.paiedTailMoney(tradeOfflineFormData);
        if(result.code == '0'){
          Toast('支付凭证保存成功!');
          this.$router.go(-1);
        }else {
          Toast(result.msg);
        }
      },
      //上传图片
      async addImage(){
        //判断是app还是浏览器访问
        var sUserAgent=navigator.userAgent;
        if(sUserAgent.endsWith("jikeWeb")){
          this.actions = [{
            name: '拍照',
            method: this.openCamera
          }, {
            name: '从相册中选择',
            method: this.selectImage
          }];
          this.sheetVisible = true;
        }else{
          //使用input文件选择
          var fileInput = document.querySelector("#image-input");
          fileInput.click();
          var that = this;
          fileInput.onchange = function(){
            var file = this.files[0];
            if(this.outerHTML){
              this.outerHTML=this.outerHTML;
            }else{      //FF
              this.value="";
            }
            Indicator.open({
              text: '加载中...',
              spinnerType: 'fading-circle'
            });
            lrz(file,{width: 1024,fieldName:'imgFile',quality:0.6}).then((rst) =>{
              return baseService.uploadImage(file);
            }).then((file) => {
              //处理image,key
              console.info(file);
              that.attachmentIds = that.attachmentIds + ',' +file.id;
              console.info(that.attachmentIds);
              that.attachmentUrlList.push(file.name)
            }).catch((err) =>{
              console.log("上传文件失败========",err);
            }).always(()=>{
              Indicator.close();
            });
          }
        }
      },
      optionImage(categoryIndex,nodeIndex,index,event){
        var that = this;
        this.actions = [
//          {
//          name: '查看',
//          method: () =>{
//            this.previewImage(categoryIndex,nodeIndex,index,event);
//          }
//        },
          {
            name: '删除',
            method: () =>{this.deleteImageFromList(index);}
      }];
        this.sheetVisible = true;
      },
      deleteImageFromList(index){

      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .picker-slot{
    font-size: 0.32rem;
  }
  .offline-tail-money-page {
    padding-bottom: 0.8rem;
    color: #1B1E29;
    font-size: 0.32rem;
    text-align: left;
    .offline-tail-money-form{
      .input-group{
        padding-top: 0.2rem;
      }
    }
    .evaluate{
      height: 0.9rem;
      line-height: 0.9rem;
      width: 6.9rem;
      padding-top: 0.27rem;
      margin: 0rem auto;
    }
    .evaluate-field{
      margin-right: 0.32rem;
    }
    .icon-select{
      width: 0.37rem;
      height: 0.39rem;
      position: relative;
      top: 0.1rem;
      margin-right: 0.2rem;
    }
    .evaluate-bad{
      padding-left: 0.4rem;
   }
  .record-img{
    margin-top: 0.28rem;
  }
  .image-area{
    background-color: #fff;
    width: 100%;
    .image-view{
      display: flex;
      flex-flow: row wrap;
      padding:0.3rem 14px;
      padding-right:0px;
      .image{
        width:1.64rem;
        height: 1.64rem;
        background: #F3F8FC;
        margin-bottom: 5px;
        margin-right:14px;
        &.add-image{
           display: flex;
           flex-flow: row wrap;
           justify-content: center;
           align-items: center;
           color: #999;
         }
        .icon-plus img{
          width: 0.8rem;
          height: 0.8rem;
          position: relative;
        }
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .image-tip{
      padding:10px;
      font-size: 14px;
      color: #999999;
    }
  }
  }
</style>
